module.exports = __webpack_public_path__ + "img/default2.1769e71c.jpg";